"use client";

import React, { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.1,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
export default function Portfolio() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return <section data-section-id="225389" id="prixdenotreprestation" className="bg-secondary/30 py-32 md:py-48 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`max-w-4xl mx-auto text-center mb-20 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-default font-extrabold tracking-tighter text-primary uppercase mb-6">
            Notre <span className="text-accent">Tarif</span>
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default max-w-2xl mx-auto">
            Une tarification transparente et adaptée à vos besoins pour une gestion sereine de votre patrimoine immobilier à Nice et sur la Côte d'Azur.
          </p>
        </div>

        <div className="text-center max-w-2xl mx-auto">
          <p className="text-2xl md:text-3xl font-default font-bold text-primary mb-4">
            25% TTC de commission, pas de frais caché
          </p>
          <p className="text-muted-foreground text-lg leading-relaxed">
            Ce tarif inclut la création et l'optimisation de l'annonce, les photos professionnelles, la gestion des ménages et du linge, la tarification intelligente.
          </p>
        </div>
      </div>
    </section>;
}